import React from 'react';
import { Helmet } from 'react-helmet-async';

const OrganizationSchema = () => {
    const schemaGraph = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": ["LocalBusiness", "EducationalOrganization"],
                "@id": "https://www.unyamee.shop/#organization",
                "name": "Unya Mee",
                "alternateName": ["Unya Mee Upcycling Studio Warsaw", "Unya Mee Sustainable Fashion Studio"],
                "description": "Artistic sustainable fashion studio and creative upcycling center offering hands-on sewing workshops and one-of-a-kind handmade garments in Warsaw, Poland.",
                "url": "https://www.unyamee.shop",
                "logo": "https://www.unyamee.shop/logo.png",
                "image": "https://www.unyamee.shop/images/workshops/main.jpg",
                "telephone": "+48604436886",
                "email": "jm.michalczak@gmail.com",
                "priceRange": "€€",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Warsaw",
                    "addressRegion": "Mazowieckie",
                    "postalCode": "00-001",
                    "addressCountry": "PL"
                },
                "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": "52.2297",
                    "longitude": "21.0122"
                },
                "areaServed": [
                    { "@type": "City", "name": "Warsaw" },
                    { "@type": "Country", "name": "Poland" },
                    { "@type": "Continent", "name": "Europe" }
                ],
                "sameAs": [
                    "https://www.instagram.com/unya_mee/"
                ],
                "paymentAccepted": "Credit Card, Cash, Bank Transfer",
                "currenciesAccepted": "PLN, EUR",
                "openingHoursSpecification": [
                    {
                        "@type": "OpeningHoursSpecification",
                        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                        "opens": "10:00",
                        "closes": "18:00"
                    }
                ],
                "knowsAbout": [
                    "Sustainable Fashion",
                    "Upcycling",
                    "Sewing Workshops",
                    "Clothing Redesign",
                    "Textile Recycling",
                    "Creative Upcycling Workshops Warsaw",
                    "Eco Fashion Poland",
                    "Slow Fashion Europe",
                    "Handmade Clothing"
                ],
                "slogan": "Sustainable fashion born from intuition"
            },
            {
                "@type": "Brand",
                "@id": "https://www.unyamee.shop/#brand",
                "name": "Unya Mee",
                "url": "https://www.unyamee.shop",
                "logo": "https://www.unyamee.shop/logo.png",
                "slogan": "Sustainable fashion born from intuition"
            }
        ]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schemaGraph)}
            </script>
        </Helmet>
    );
};

export default OrganizationSchema;
